import { loadResourceFiles, uploadResourceFile } from '@/core/migration/supportMigrationFunctions'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { initDataInBoolean, initDataInTextInput } from '@/core/item_assistance/initializeComponentData'
import { getDataFromBoolean } from '@/core/item_assistance/receiveDataFromComponents'

export function EditExportConfigManager (companyId) {
	this.global = !companyId

	this.editableMigration = {}
	this.migrationConfig = {}
	this.tagId = null

	this.setEditableMigration = function (migration) {
		this.editableMigration = migration
		if (!_.has(this.editableMigration, 'parameters')) {
			this.editableMigration.parameters = {}
		}
	}

	this.renderExportExcelTemplate = function () {
		$('#migration-excel-stream-output').css('display', 'block')
		$('#migration-required-fields-only').css('display', 'block')
		$('#migration-left-attribute-names').css('display', 'block')
		$('.xslt-file_select').css('display', 'block')
		$('.file-input_excelTemplate').css('display', 'block')
		$('.excel-template-sample').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.renderExportXmlTemplate = function () {
		$('#migration-required-fields-only').css('display', 'block')
		$('.xslt-file_select').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.renderExportJsonTemplate = function () {
		$('#migration-required-fields-only').css('display', 'block')
		$('.xslt-file_select').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.renderExportPdfTemplate = function () {
		$('.xslt-file_select').css('display', 'block')
		$('.filename-pattern').css('display', 'block')
	}

	this.initEditMigrationForm = function (table) {
		var manager = this

		Swal.fire({
			title: getLocalizedMessage('edit.configuration'),
			html: '<div class="modal_item">\n' +
				'    <div class="new-migration_name">\n' +
				'        <label id="migration-name_label" for="migration-name">' + getLocalizedMessage('configuration.name') + '</label>\n' +
				'        <br>\n' +
				'        <input id="migration-name" type="text" class="textInput attribute-editor">\n' +
				'        <button class="button_reset fa fa-times"></button>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'    <div id="new-migration_transformation-tag" class="new-migration_transformation-tag">\n' +
				'        <label id="transformation-tag_label" for="transformation-tag">' + getLocalizedMessage('transformation.tag') + '</label>\n' +
				'        <br>\n' +
				'        <select id="transformation-tag" class="select attribute-editor">\n' +
				'\n' +
				'        </select>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'    <div class="new-migration_transformation-type">\n' +
				'        <label id="transformation-type_label" for="transformation-type">' + getLocalizedMessage('transformation.type') + '</label>\n' +
				'        <br>\n' +
				'        <select id="transformation-type" class="select attribute-editor">\n' +
				'            <option value=""></option>\n' +
				'        </select>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
                '    <p id="transformation-type-limit" class="transformation-type-limit" style="display:none"></p>\n' +
                '</div>\n' +
				'<div class="modal_item">\n' +
				'    <div class="new-migration_parameters migration-paramters">\n' +
				'        <br>\n' +
				'        <div class="modal_item"><label id="migration-parameters" style="display: none">' + getLocalizedMessage('migration.parameters') + '</label></div>\n' +
				'        <div id="migration-debug-mode" class="modal_item" style="display: none">\n' +
				'            <label for="debug-mode">' + getLocalizedMessage('debug.mode') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="debug-mode">\n' +
				'        </div>\n' +
				'        <div id="migration-excel-stream-output" class="modal_item" style="display: none">\n' +
				'            <label for="required-fields-only">' + getLocalizedMessage('migration.excel.stream.output') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="excel-stream-output">\n' +
				'        </div>\n' +
				'        <div id="migration-required-fields-only" class="modal_item" style="display: none">\n' +
				'            <label for="required-fields-only">' + getLocalizedMessage('migration.required.fields.only') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="required-fields-only">\n' +
				'        </div>\n' +
				'        <div id="migration-left-attribute-names" class="modal_item" style="display: none">\n' +
				'            <label for="left-attribute-names">' + getLocalizedMessage('migration.left.attribute.names') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="left-attribute-names">\n' +
				'        </div>\n' +
				'        <div class="csv-format-list modal_item" style="display: none">\n' +
				'            <label id="csv-format-list_label" for="csv-format-list">' + getLocalizedMessage('csv.format.list') + '</label>\n' +
				'            <br>\n' +
				'            <select id="csv-format-list" class="select attribute-editor">\n' +
				'                <option value="default">default</option>\n' +
				'                <option value="excel">excel</option>\n' +
				'                <option value="excel_semicolon">excel_semicolon</option>\n' +
				'                <option value="mysql">mysql</option>\n' +
				'                <option value="rfc4180">rfc4180</option>\n' +
				'                <option value="tdf">tdf</option>\n' +
				'            </select>\n' +
				'        </div>\n' +
				'        <div class="filename-pattern modal_item" style="display: none">\n' +
				'            <div class="new-migration_filename-pattern">\n' +
				'                <label id="transformation-type_label" for="filename-pattern">' + getLocalizedMessage('filename.pattern') + '</label>\n' +
				'                <br>\n' +
				'                <input id="filename-pattern" type="text" class="textInput attribute-editor">\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="xslt-file_select modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('xslt.file') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <select id="xslt-file" class="select select-with-add attribute-editor"></select>\n' +
				'                <input id="xslt-file-input" class="attribute-editor" type="file" accept=".xsl" style="display:none;"/>\n' +
				'                <button id="xslt-file-button" class="button_plus fa fa-plus" tabindex="-1"></button>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="file-input_excelTemplate modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('export.template') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <select id="excel-template" class="select select-with-add attribute-editor"></select>\n' +
				'                <input id="excel-template-input" class="attribute-editor" type="file" accept=".xlsx,.xls" style="display:none;"/>\n' +
				'                <button id="excel-template-button" class="button_plus fa fa-plus" tabindex="-1"></button>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="excel-template-sample modal_item" style="display: none">\n' +
				'            <a>' + getLocalizedMessage('migration.excel.template.sample') + '</a>\n' +
				'        </div>\n' +
				'        <div class="string-value_1 modal_item" style="display: none">\n' +
				'            <label id="string-value-1_label" for="string-value-1"></label>\n' +
				'            <br>\n' +
				'            <input id="string-value-1" type="text" class="textInput attribute-editor">\n' +
				'            <button class="button_reset fa fa-times"></button>\n' +
				'        </div>\n' +
				'        <div class="string-value_2 modal_item" style="display: none">\n' +
				'            <label id="string-value-2_label" for="string-value-2"></label>\n' +
				'            <br>\n' +
				'            <input id="string-value-2" type="text" class="textInput attribute-editor">\n' +
				'            <button class="button_reset fa fa-times"></button>\n' +
				'        </div>\n' +
				'        <div class="file-input_importSample modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('import.sample') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <input id="import-sample" class="attribute-editor" type="file"/>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'    </div>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				$('#transformation-type').attr('disabled', 'disabled')
				$('#new-migration_transformation-tag').show()

				manager.bindAddResourceButtons()

				var xsltForSelect
				if (manager.editableMigration.parameters.xslt) {
					xsltForSelect = manager.editableMigration.parameters.xslt[0]
				}
				loadResourceFiles($('#xslt-file'), 'xslt', true, !manager.global, xsltForSelect)

				var templateForSelect
				if (manager.editableMigration.parameters.excelTemplate) {
					templateForSelect = manager.editableMigration.parameters.excelTemplate
				}
				loadResourceFiles($('#excel-template'), 'excel', true, !manager.global, templateForSelect)

				manager.initSelectedParameters()

				tagManager.getTags(manager.renderEditMigrationParameters.bind(manager))
				bindResetButtonModal()
			},
			preConfirm: function (inputValue) {
				manager.getEditMigrationParameters()
				return manager.migrationConfig
			}
		}).then(function (result) {
			if (result.value) {
				manager.updateMigration(table)
			}
		})
	}

	this.bindAddResourceButtons = function () {
		var manager = this

		var excelTemplateInputSelector = $('#excel-template-input')
		excelTemplateInputSelector.unbind('change')
		excelTemplateInputSelector.change(function () {
			var file = Array.from(excelTemplateInputSelector.get(0).files)[0]
			excelTemplateInputSelector.get(0).value = ''
			if (file == null) {
				return
			}

			uploadResourceFile(manager.global, file, function (data) {
				var name = data['name']
				if (manager.global) {
					name = 'global/' + name
				}
				loadResourceFiles($('#excel-template'), 'excel', true, !manager.global, name)
			})
		})

		var excelTemplateButtonSelector = $('#excel-template-button')
		excelTemplateButtonSelector.unbind('click')
		excelTemplateButtonSelector.click(function () {
			excelTemplateInputSelector.click()
		})

		var xsltFileInputSelector = $('#xslt-file-input')
		xsltFileInputSelector.unbind('change')
		xsltFileInputSelector.change(function () {
			var file = Array.from(xsltFileInputSelector.get(0).files)[0]
			xsltFileInputSelector.get(0).value = ''
			if (file == null) {
				return
			}

			uploadResourceFile(manager.global, file, function (data) {
				var name = data['name']
				if (manager.global) {
					name = 'global/' + name
				}
				loadResourceFiles($('#xslt-file'), 'xslt', true, !manager.global, name)
			})
		})

		var xsltFileButtonSelector = $('#xslt-file-button')
		xsltFileButtonSelector.unbind('click')
		xsltFileButtonSelector.click(function () {
			xsltFileInputSelector.click()
		})

		var excelTemplateSample = $('.excel-template-sample')
		excelTemplateSample.unbind('click')
		excelTemplateSample.click(function () {
			downloadManager('/export-config/excel/template')
		})
	}

	this.initSelectedParameters = function () {
		if (this.editableMigration.parameters) {
			if (this.editableMigration.parameters.excelStreamOutput) {
				initDataInBoolean('excel-stream-output', this.editableMigration.parameters.excelStreamOutput)
			}
			if (this.editableMigration.parameters.requiredFieldsOnly) {
				initDataInBoolean('required-fields-only', this.editableMigration.parameters.requiredFieldsOnly)
			}
			if (this.editableMigration.parameters.leftAttributeNames) {
				initDataInBoolean('left-attribute-names', this.editableMigration.parameters.leftAttributeNames)
			}
			if (this.editableMigration.parameters.filenamePattern) {
				initDataInTextInput('filename-pattern', this.editableMigration.parameters.filenamePattern)
			}
			initDataInBoolean('debug-mode', this.editableMigration.parameters.debug)
		}
	}

	this.renderEditMigrationParameters = function () {
		$('#migration-parameters').css('display', 'block')
		$('#migration-debug-mode').css('display', 'block')

		$('#migration-name').val(this.editableMigration['name'])

		var transformationTagSelector = $('#transformation-tag')
		transformationTagSelector.val('').change()
		transformationTagSelector.val(this.editableMigration['tagId']).change()

		var transformationTypeSelector = $('#transformation-type')
		transformationTypeSelector.append('<option value=\'' + this.editableMigration['type'] + '\'>' + this.editableMigration['type'] + '</option>')
		transformationTypeSelector.val(this.editableMigration['type'])
		transformationTypeSelector.addClass('def-val')

		if (this.editableMigration['type'] === 'EXCEL') {
			this.renderExportExcelTemplate()
		}
		if (this.editableMigration['type'] === 'XML') {
			this.renderExportXmlTemplate()
		}
		if (this.editableMigration['type'] === 'PDF') {
			this.renderExportPdfTemplate()
		}
		if (this.editableMigration['type'] === 'JSON') {
			this.renderExportJsonTemplate()
		}

		this.renderTransformationTypeLimit()
	}

	this.renderTransformationTypeLimit = function () {
        var limits = {
                EXCEL: getLocalizedMessage('export.limit.excel'),
                PDF: getLocalizedMessage('export.limit.pdf')
        }
        var text = limits[this.editableMigration['type']]
        $('#transformation-type-limit').text(text || '').css('display', text ? 'block' : 'none')
  	}

	this.getEditMigrationParameters = function () {
		this.migrationConfig['id'] = this.editableMigration['id']
		this.migrationConfig['name'] = $('#migration-name').val()
		this.migrationConfig['type'] = this.editableMigration['type']
		this.migrationConfig['companyId'] = companyId
		this.migrationConfig['tagId'] = nullOnEmpty($('#transformation-tag').val())

		var params = {}

		var xslt = $('#xslt-file').val()
		if (xslt) {
			params.xslt = [xslt]
		}
		var filenamePattern = $('#filename-pattern').val();
		if (filenamePattern) {
			params.filenamePattern = filenamePattern;
		}

		params.debug = getDataFromBoolean('debug-mode')

		if (this.editableMigration['type'] === 'XML') {
			params.requiredFieldsOnly = getDataFromBoolean('required-fields-only')
		} else if (this.editableMigration['type'] === 'EXCEL') {
			params.excelTemplate = nullOnEmpty($('#excel-template').val())
			params.requiredFieldsOnly = getDataFromBoolean('required-fields-only')
			params.leftAttributeNames = getDataFromBoolean('left-attribute-names')
			params.excelStreamOutput = getDataFromBoolean('excel-stream-output')
		} else if (this.editableMigration['type'] === 'JSON') {
			params.requiredFieldsOnly = getDataFromBoolean('required-fields-only')
		} else if (this.editableMigration['type'] === 'PDF') {
		}

		this.migrationConfig.parameters = params

		function nullOnEmpty (value) {
			return value !== '' ? value : null
		}
	}

	this.deleteMigration = function (migration, table) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('delete') + ' ' + migration['name'] + '?',
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				var prefix = manager.global ? 'global/' : ''
				var url = prefix + 'export-config/' + migration['id'] + '/delete'
				$.ajax({
					url: window.urlContext + url,
					type: 'POST',
					async: false,
					success: function () {
						table.initTable()
						showMessageAlert(getLocalizedMessage('success'), 'success')
					},
					error: function (response) {
						if (response.status === 409) {
							showMessageAlert(getLocalizedMessage('unresolved.references.exist'), 'danger')
						} else {
							showMessageAlert(getLocalizedMessage('error'), 'danger')
						}
					}
				})
			}
		})
	}

	this.updateMigration = function (table) {
		var prefix = this.global ? 'global/' : ''
		var url = prefix + 'export-config/' + this.migrationConfig['id'] + '/save'
		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			async: true,
			context: this,
			contentType: 'application/json; charset=UTF-8',
			data: JSON.stringify(this.migrationConfig),
			success: function () {
				table.initTable()
				showMessageAlert(getLocalizedMessage('success'), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error'), 'danger');
			}
		});
	};
}
